async function sendEmail(form){
    try{
    const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/send-email', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_SECRET_KEY
        },
        body: JSON.stringify(form),
        });

        const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || 'Failed to send message.');
    }

    return { success: true, message: data.message };
    
  } catch (error) {
    console.error('Contact Service Error:', error);
    return { success: false, error: error.message || 'Network error. Please check your connection.' };
  }
}

export default sendEmail